import React from "react";

export default function AddWishListThemeDefault({params}) {

    let heartImg;

    if (params.states.isEx === true) {
        heartImg = <img src="/assets/images/icons/heart-active.png"/>


        return <div className="catalog-action-item favorite" onClick={params.actions.remove.bind(this)}>
            {heartImg}
        </div>;


    } else {
        heartImg = <img src="/assets/images/icons/heart-black.png"/>


        return <div className="catalog-action-item favorite" onClick={params.actions.handleClick.bind(this)}>
            {heartImg}
        </div>;
    }
}